<template>
    <div class="modal-backdrop" @click.self="$emit('close')">
      <div class="modal-content">
        <h3>{{ $t('noahai.feedback.title') }}</h3>  
   
        <div v-if="showSuccess" class="success-message">{{ $t('noahai.feedback.success') }}
        </div>
   
        <div v-else>
          <label>{{ $t('noahai.feedback.title_label') }}</label>
          <input v-model="title" :placeholder="$t('noahai.feedback.title_placeholder')" />
  
          <label>{{ $t('noahai.feedback.type_label') }}</label>
          <select v-model="type">
            <option value="Faydalı">{{ $t('noahai.feedback.type_useful') }}</option>
            <option value="Yanıt yetersiz">{{ $t('noahai.feedback.type_insufficient') }}</option>
            <option value="Yanıt yanlış">{{ $t('noahai.feedback.type_wrong') }}</option>
          </select>
  
          <label>{{ $t('noahai.feedback.message_label') }}</label>
          <textarea v-model="feedback" :placeholder="$t('noahai.feedback.message_placeholder')" rows="4"></textarea>
  
          <div class="actions">
            <button class="send-btn" @click="submitFeedback">{{ $t('noahai.feedback.send') }}</button>
            <button class="close-btn" @click="$emit('close')">{{ $t('noahai.feedback.close') }}</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  import { ref } from "vue";
  import { useI18n } from "vue-i18n";
  import axios from "axios";
  
  export default {
    props: ['messageId', 'chatId'],
    emits: ['close'],
    setup(props, { emit }) {
      const { t } = useI18n();
      const feedback = ref("");
      const title = ref("");
      const type = ref("Faydalı");
      const showSuccess = ref(false);
  
      const submitFeedback = async () => {
        if (feedback.value.length < 10) {
          alert(t("noahai.feedback.min_length_error"));
          return;
        }
  
        const combinedFeedback = `
        [Başlık]: ${title.value || '-'} 
        [Tür]: ${type.value}
        [Mesaj]: ${feedback.value}
        `;
  
        try {
          await axios.post("/promo/user/noahaura/feedback", {
            chat_id: props.chatId,
            message_id: props.messageId,
            feedback: combinedFeedback.trim()
          });
   
          showSuccess.value = true;
   
          setTimeout(() => {
            showSuccess.value = false;
            feedback.value = "";
            title.value = "";
            type.value = "Faydalı";
            emit('close');
          }, 3000);
  
        } catch (err) {
          console.error("Feedback gönderilemedi:", err);
        }
      };
  
      return { feedback, title, type, submitFeedback, showSuccess };
    }
  }
  </script>
  
  
  
  <style scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  
  .modal-content {
    background-color: #050505;
    padding: 1.5em;
    border-radius: 10px;
    border: 1px solid #022121;
    min-width: 320px;
    display: flex;
    flex-direction: column; 
    gap: 5px;
  }
  
  input, textarea, select {
    width: 100%;
    padding: 0.5em;
    border-radius: 5px; 
  }
  
  textarea {
    resize: none;
  }
  
  button {
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .send-btn {
    background: #065959;
    color: white;
  }
  
  .send-btn:hover {
    background: #053737;
  }
  
  .close-btn {
    background: #0e0e0e;
    color: white;
  }
  
  .close-btn:hover {
    background: #252525;
  }
  
  .actions {
    display: flex;
    justify-content: space-between;
    margin-top: 0.5rem;
  }
  
  .success-message {
  background: #000;
  color: #227a41;
  padding: 1rem;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
  transition: opacity 0.3s ease;
}
  </style>
  